import * as types from '../../mutations-types';
export default {
  [types.MOBILEGAME_FETCH]: (state, { filters, games }) => {
    state.filters = filters.code === 1 ? filters.data : []
    state.games = games.code === 1 ? games.data.data : []
    state.total = games.code === 1 ? games.data.total : 0
  }
}
